import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import * as HighCharts from 'highcharts';
import { ServiceProvider } from '../../../providers/ServiceProvider';
import { LoginPage } from '../../Login/Login';
import { CapReportPage } from '../CapReport/CapReport';


/*
  Generated class for the Charts page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-Charts',
    templateUrl: 'Charts.html'
})
export class ChartsPage {

    constructor(public navCtrl: NavController, public navParams: NavParams, public serviceProvider: ServiceProvider) { }
    public Charts: any = [];
    ionViewDidLoad() {
        console.log('ionViewDidLoad ChartsPage');

        this.serviceProvider.Get("VirtualForms/Customer/20399", true).then((result) => {
            var charts: any = result;
            charts.forEach((value, index) => {
                this.Charts.push(value);
            });
            console.log(this.Charts);
        });


        //var myChart = HighCharts.chart('container', {
        //    chart: {
        //        type: 'bar'
        //    },
        //    title: {
        //        text: 'Fruit Consumption'
        //    },
        //    xAxis: {
        //        categories: ['Apples', 'Bananas', 'Oranges']
        //    },
        //    yAxis: {
        //        title: {
        //            text: 'Fruit eaten'
        //        }
        //    },
        //    series: [{
        //        name: 'Jane',
        //        data: [1, 0, 4]
        //    }, {
        //        name: 'John',
        //        data: [5, 7, 3]
        //    }]
        //});

    }

    ShowData(chart) {
        chart.Loading = true;
        if (chart.tMDId85_AppShowType != 291) {
            this.ShowChart(chart);
        }
        else {
            this.ShowImage(chart);
        }
    }
    ShowImage(chart) {
        if (chart.Showing == null || chart.Showing == false) {
            chart.Showing = true;
        }
        else {
            chart.Showing = false;
        }
        if (chart.hasData == true) {
            chart.Loading = false;
            return;
        }
        this.serviceProvider.Get("/ISPA_VFToken?codId=" + chart.tCustomerODataId, true).then((result) => {
            chart.data = result;
            chart.Loading = false;
            chart.hasData = true;
            console.log(chart);
        });
    }
    ShowCap() {
        this.navCtrl.push(CapReportPage);
    }
    ShowChart(chart) {
        if (chart.Showing == null || chart.Showing == false) {
            chart.Showing = true;
        }
        else {
            chart.Showing = false;
        }
        if (chart.hasData == true) {
            chart.Loading = false;
            return;
        }
        this.serviceProvider.Get("/ISPA_VFToken?codId=" + chart.tCustomerODataId, true).then((result) => {
            console.log(result);
            let Data: any = result;
            let xAxis: any = [];
            let series: any = [];
            let SeriesName: string;
            let XAxisName: string;
            Data.forEach((value, index) => {
                xAxis.push(value.cdValue1_txt);
                series.push(parseFloat(value.cdValue2_txt));
                XAxisName = value.odLabel1;
                SeriesName = value.odLabel2;
            });
            chart.Loading = false;
            chart.hasData = true;
            var myChart = HighCharts.chart('container' + chart.tCustomerODataId, {
                chart: {
                    type: 'column'
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: xAxis
                },
                yAxis: {
                    min:0,
                    title: {
                        text: SeriesName
                    }
                },
                series: [{
                    name: SeriesName,
                    data: series,
                    color: chart.odColor
                }]
            });
        });
    }


}



// WEBPACK FOOTER //
// ./src/pages/atlas/Charts/Charts.ts